import { Search } from 'lucide-react'
const ButtonSearchbar = ({ title, onSearch, btnText, value, className }: {
  title?: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  btnText: string;
  value?: string;
  className?: string;
}) => {
  return (
    <div className="flex justify-between mb-6">
      {title && (
        <h2 className="hidden md:block text-xl font-semibold ">{title}</h2>
      )}
      <div className={`flex items-center w-full ${className ?? "max-w-lg"} h-[39px] rounded-md border border-gray-300 overflow-hidden bg-white`}>
        <Search className="ml-3 h-4 w-4 text-gray-500" />
        <input
          type="text"
          placeholder="Search by title name or context"
          className="w-full px-3 py-2 outline-none text-sm bg-white text-black"
          onChange={onSearch}
          value={value ?? ""}
        />
        <button className="bg-black text-white px-4 py-2 text-sm">{btnText}</button>
      </div>

    </div>
  )
}

export default ButtonSearchbar